import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { SearchContext } from "../contexts/SearchContext";
import { LoadingContext } from "../contexts/LoadingContext";
import { PaginationResponse } from "../objects/pagination";
import { Admin } from "../models/system/admin";
import { getAdmins } from "../services/inventory/SystemApi";
import { getPagination } from "../utils/helper";
import { errorToast } from "../utils/helper-ui";
import { Button, Checkbox, IconButton, Table } from "rsuite";
import PlusIcon from "@rsuite/icons/Plus";
import { Role } from "../models/system/role";
import AdminForm from "../components/features/system/AdminForm";
const { Column, HeaderCell, Cell } = Table;

interface AdminPageProps {}

const AdminPage: FC<AdminPageProps> = ({}) => {
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(30);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [admins, setAdmins] = useState<Admin[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState<Admin>();

  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === admins.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < admins.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? admins.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    fetchData();
  }, [mounted, search, page, size]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getAdmins({ page, size, search });
      const resJson = await res.json();
      //   console.log(data);
      setAdmins((prev) => [...prev, ...resJson.data.items]);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Admin</h1>
      {/* button */}
      <div>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Create Admin
        </IconButton>
      </div>
    </div>
  );

  return (
    <MainLayout header={renderHeader()}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th
                className="px-4 py-2 text-left border bg-gray-50"
                style={{ width: 100 }}
              >
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Name</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Avatar</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Email</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Role</th>
            </tr>
          </thead>
          <tbody>
            {admins.map((rowData, i) => (
              <tr key={i}>
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={rowData.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((item) => item === rowData.id)}
                  />
                  {i + 1}
                </td>
                <td className="px-4 py-2 border">
                  <div
                    
                    onClick={() => {
                      setSelectedAdmin(rowData);
                      setModalFormOpen(true);
                    }}
                  >
                    {rowData.full_name}
                  </div>
                </td>
                <td className="px-4 py-2 border">
                  {rowData.profile_picture && (
                    <div>
                      <img
                        src={rowData.profile_picture.url}
                        alt="avatar"
                        className="w-10 h-10 rounded-full"
                      />
                    </div>
                  )}
                </td>
                <td className="px-4 py-2 border">{rowData.email}</td>
                <td className="px-4 py-2 border">
                  {rowData.roles && (
                    <div>
                      {rowData.roles.map((role: Role) => role.name).join(", ")}
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!pagination?.last && (
        <div className="flex justify-center my-2">
          <Button
            onClick={() => {
              setPage((pagination?.page ?? 0) + 1);
            }}
          >
            Load more
          </Button>
        </div>
      )}
      {/* <Table minHeight={700} data={admins} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>
                {(page - 1) * size + admins.indexOf(rowData as Admin) + 1}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  setSelectedAdmin(rowData as Admin);
                  setModalFormOpen(true);
                }}
              >
                {rowData.full_name}
              </div>
            )}
          </Cell>
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Avatar</HeaderCell>
          <Cell style={{ padding: 2 }}>
            {(rowData) => rowData.profile_picture &&(
              <div>
                <img
                  src={rowData.profile_picture.url}
                  alt="avatar"
                  className="w-10 h-10 rounded-full"
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Email</HeaderCell>
          <Cell dataKey="email" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Role</HeaderCell>
          <Cell>
            {(rowData) => rowData.roles && (
              <div>
                {rowData.roles.map((role: Role) => role.name).join(", ")}
              </div>
            )}
          </Cell>
        </Column>
      </Table> */}
      <AdminForm
        open={modalFormOpen}
        onClose={() => setModalFormOpen(false)}
        onSubmit={(data) => {
          fetchData();
          setModalFormOpen(false);
          setAdmins([]);
        }}
        admin={selectedAdmin}
      />
    </MainLayout>
  );
};
export default AdminPage;
